import axios from "axios";
import { API } from "../utilities/api.config";

function emailDisclosure(data) {
  const request = () =>
    axios.post(`${API.EMAIL_DISCLOSURE}`, data, {
      headers: { Authorization: `${localStorage.getItem("wbiAuthToken")}` },
    });
  return (dispatch) => {
    dispatch({ type: "EMAIL_DISCLOSURE_REQUESTED" });
    request()
      .then((response) => {
        dispatch({
          type: "EMAIL_DISCLOSURE_SUCCESS",
          payload: response.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: "EMAIL_DISCLOSURE_FAIL",
          payload: error,
        });
      });
  };
}

export const disclosureAction = {
  emailDisclosure,
};

export default disclosureAction;



// WEBPACK FOOTER //
// ./src/actions/disclosure.action.js